export { default } from './MinimumOrderQuantity';